import { useEffect, useState } from "react";
import axios from "axios";
import Fade from "react-reveal/Fade";
import spotifySvg from "../assets/icons/spotify.svg"
function About() {
  const [tracks, setTracks] = useState<any[] | null>();
  const [playlists, setPlaylists] = useState<any[] | null>();
  const [steamUser, setSteamUser] = useState<any | null>();
  const [loading, setLoading] = useState(true);

  const TOP_TRACKS_ENDPOINT =
    "https://myspotifystats-git-main-skezam92-gmailcom.vercel.app/api/top-tracks";
  const PLAYLISTS_ENDPOINT =
    "https://myspotifystats-git-main-skezam92-gmailcom.vercel.app/api/me-playlists";

  useEffect(() => {
    setLoading(true);
    axios.get(TOP_TRACKS_ENDPOINT).then((response: any) => {
      setTracks(response.data.items);
    });
    axios.get(PLAYLISTS_ENDPOINT).then((response: any) => {
      setPlaylists(response.data.items);
    });
    setLoading(false);
  }, []);

  return (
    <Fade>
      <div id="about">
        <h2 className="text-2xl font-bold sm:text-3xl mb-6">More about me</h2>
        <p className="text-justify mb-5">
          <span className="opacity-90">
            I have a few different educational qualifications that I think have
            contributed to my success in my current position. I started my
            studies with a DUT in informatique from{" "}
          </span>
          <span className="text-red-400 opacity-90 font-bold">
            Paris Descartes.
          </span>
          <br />
          <span className="opacity-90">
            This two-year degree gave me a strong foundation in computer science
            and information technology. After that, I completed a one-year
            bachelor's degree in web development, which allowed me to gain more
            specialized skills in this area. Finally, I completed a master's
            degree in digital transformation, which gave me a broad
            understanding of how technology is changing the way businesses
            operate. Overall, I believe that my combination of technical skills
            and broad knowledge of digital transformation has been key to my
            success in my current job. I'm excited to continue learning and
            growing in this field.
          </span>
        </p>
        <h2 className="text-2xl font-bold sm:text-3xl mb-6">Music</h2>
        <p className="text-justify mb-5">
          <span className="opacity-90">
            House and tech music have always been a favorite of mine. The
            origins of my interest in these genres can be attributed to my
            exposure to them at a young age, as my father was a DJ in the 1980s
            and frequently played these styles of music at home. Since then, my
            appreciation for house and tech music has only grown and it has
            become my go-to choice for various occasions. Whether I am out
            dancing or simply looking for background music at home, these genres
            always provide an energetic and enjoyable listening experience. In
            recent weeks, my Spotify playlist has been filled with a variety of
            house and tech tracks. I have been consistently drawn to the
            energetic and upbeat sound that these genres offer.
          </span>
        </p>
        <div className="text-center">
          <img
            src="https://www.pioneerdj.com/-/media/pioneerdj/images/landing/virgil-abloh/190520/img-01.png"
            className="animate-pulse rounded-xl drop-shadow-xl hover:scale-105 hover:-translate-y-0 duration-300 opacity-90 hover:opacity-100"
            alt="Virgil Abloh controller"
          />
          <p className="italic">
            <span className="opacity-50 underline">Virgil Abloh</span>
            <span className="opacity-100"> 🕊️ </span>
            <span className="opacity-50">Pioneer Controller</span>
          </p>
        </div>
        <h2 className="text-lg font-bold sm:text-xl opacity-90 mt-10">
          My fav playlists
        </h2>
        {!playlists && (
          <svg
            aria-hidden="true"
            className="m-auto w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-purple-800"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        )}
        <div className="grid md:grid-cols-2 sm:grid-cols-2 xs:grid-cols-1 mt-5 gap-4">
          {playlists &&
            playlists.map((playlist) => (
              <>
                <div key={playlist.id}>
                  <div className="flex items-center space-x-5 p-2 flex-grow w-100">
                    <img
                      src={playlist.images[0]?.url}
                      alt={playlist.name}
                      width={60}
                      className="rounded-lg"
                    />
                    <div className="flex-auto">
                      <div className="flex">
                        <p className="text-white font-bold opacity-95 mr-2">
                          {playlist.name}
                        </p>
                        <a
                          href={playlist.uri}
                          target="_blank"
                          rel="noreferrer"
                          className="ml-auto"
                        >
                          <img
                            src={spotifySvg}
                            alt="logo spotify"
                            width={20}
                            className="rounded-lg"
                          />
                        </a>
                      </div>
                      <p className="opacity-50 ">
                        {playlist.tracks.total} tracks
                      </p>
                    </div>
                  </div>
                </div>
              </>
            ))}
        </div>
        <h2 className="text-lg font-bold sm:text-xl opacity-90 mt-10">
          Couples of most listened songs during the last few weeks
        </h2>
        {!tracks && (
          <svg
            aria-hidden="true"
            className="m-auto w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-purple-800"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        )}
        <div className="grid md:grid-cols-2 sm:grid-cols-2 xs:grid-cols-1 mt-5 gap-4">
          {tracks &&
            tracks.map((track) => (
              <a href={track.uri}>
                <div
                  key={"track" + track.id}
                  className="flex items-center space-x-5 drop-shadow-xl bg-zinc-800 rounded-xl p-2 hover:scale-95 hover:-translate-y-0 duration-300"
                >
                  <img
                    src={track.album.images[0].url}
                    alt={track.artists[0].name}
                    width={60}
                    className="rounded-lg"
                  />
                  <div>
                    <p className="text-white font-bold opacity-95">
                      {track.name}
                    </p>
                    <p className="opacity-50">{track.artists[0].name}</p>
                  </div>
                </div>
              </a>
            ))}
        </div>
      </div>
    </Fade>
  );
}

export default About;
